import React from 'react';
import profile from '../media/jcbodyshort.jpg';
import './LinkInBio.css';

import {bioLinks} from '../content/linkinbio/links';

export default function LinkInBio() {
  const activeLinks = bioLinks.filter((l) => l.active);

  return (
    <div className='linkInBio'>
      <div className='linkInBioPage text-center'>
        <img
          src={profile}
          alt='Jane Corry Profile'
          className='m-auto my-1'
        />

        <h1>Jane Corry</h1>
        <h3>important links</h3>

        {activeLinks.map((link) => (
          <a
            key={link.id}
            href={link.url}
            target='_blank'
            rel='noreferrer'
            className='px-3 linkLightBase'>
            <div className='link m-1 mt-3 m-sm-2 p-3 p-sm-4'>{link.label}</div>
          </a>
        ))}
      </div>


    </div>
  );
}
